import { Dialog, DialogContent } from "common/components/ui/Dialog";
import { Drawer, DrawerContent } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import LinkedInLogin, { type LinkedInLoginProps } from "./LinkedInLogin";

interface LinkedInLoginModalProps
  extends Omit<LinkedInLoginProps, "goBack" | "onSuccess"> {
  isOpen: boolean;
  onClose: () => void;
}

export default function LinkedInLoginModal({
  isOpen,
  onClose,
  ...rest
}: LinkedInLoginModalProps) {
  const isDesktop = useTwBreakpoint("lg");

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;

  return (
    <Component
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <Content size="lg">
        <LinkedInLogin onSuccess={onClose} {...rest} />
      </Content>
    </Component>
  );
}
